import Axios from "@/plugins/axios";

class CandidacyApi {
    getCandidacyByUser(userId) {
        return Axios.get('api/user/' + userId + '/candidacy');
    }

    updateCandidacy(idCandidacy, data) {
        return Axios.put('api/candidacies/' + idCandidacy, data);
    }

    sendCandidacy(userId) {
        return Axios.post('api/user/' + userId + '/candidacy/send', {});
    }

    extendCandidacy(userId) {
        return Axios.post('api/user/' + userId + '/candidacy/extend', {});
    }
}

export default new CandidacyApi();
